if (!customElements.get('details-accordion')) {
    customElements.define('details-accordion', class DetailsAccordion extends HTMLElement {
        constructor() {
            super();
            this.querySelector('.details-accordion__heading').addEventListener("click", (event) => {
                const detailsAccordion = event.target.parentNode;
                if (detailsAccordion.getAttribute("open") === null) {
                    detailsAccordion.setAttribute("open", "");
                } else {
                    detailsAccordion.removeAttribute("open");
                }
            });
        }
    });
}